import { DataTable, Typography, type ColumnDef } from "@/deps/ui-library";
import type { AccountGroup } from "@/api/types";
import { byClass } from "@/lib/chart";

/**
 * Accounts grouped by class, a small table per class under its name and count. The picker's preview and
 * onboarding's required accounts read this way; Settings lists the chart as one table.
 */
export function ClassTables<T extends { group: AccountGroup; code: string }>({
  rows,
  columns,
  label,
  rowId,
  count,
}: {
  rows: readonly T[];
  columns: Array<ColumnDef<T>>;
  /** Names each table, "Assets · NFRS for SMEs" say, so a screen reader can tell them apart. */
  label: (group: AccountGroup) => string;
  /** How many the heading counts, when not every row is an account. */
  count?: (rows: T[]) => number;
  rowId: (row: T) => string;
}) {
  return (
    <div className="flex flex-col gap-4">
      {byClass(rows).map(({ group, accounts }) => (
        <section key={group} className="flex flex-col gap-1">
          <Typography.Text as="p" weight="semibold" className="m-0">
            {`${group} · ${count ? count(accounts) : accounts.length}`}
          </Typography.Text>
          <DataTable
            aria-label={label(group)}
            size="sm"
            enableSorting={false}
            columns={columns}
            data={accounts}
            getRowId={rowId}
            pagination={{ mode: "manual", show: false }}
          />
        </section>
      ))}
    </div>
  );
}
